<template>
  <div class="mx-5">
    <span class="helvetica-medium billing-period-text" :class="dashboardClass">
      <div class="mb-3">{{header}}</div>
      <div v-html="message"></div>

    </span>
  
  </div>
</template>

<script>
export default {
  name: "BillingPeriodMessage",
  props: {
    dashboardClass: {
      type: String,
      default: "",
    },
    message:{
      type: String,
      default: ""
    },
   header:{
      type: String,
      default: ""
    }
  },
};
</script>

<style lang="scss" scoped>
.billing-period-text {
  display: block;
  text-align: center;
  border: 2px solid $main-orange;
  border-radius: 8px;
  padding: 16px 0 16px 0;
  font-size: 19px;
}

.dashboard-billing-period {
  border-radius: 24px;
  margin: 16px auto;
  max-width: 300px;
}
.billingClose {
  position: relative;
}

@media screen and (max-width: 768px) {
  .billing-period-text {
    font-size: 14px;
  }
}
</style>